import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import styled from 'styled-components';

import {
  Button,
  Grid,
  IconButton,
} from '@material-ui/core';

import {
  DeleteOutlined,
  RotateRightOutlined,
} from '@material-ui/icons';

import Pedal from '../../atoms/Pedal';
import Board from '../../molecules/Board';
import Layout from '../Layout';
import withTheme from '../../Theme';
import { setBoard as setBoardAction } from '../../store/board/actions';
import { withPedalsCtx, withPedalsProvider } from '../../organisms/Pedalboard/context';

const WrapperContainer = styled.div`
  @media (max-width: ${props => props.theme.media.md}) {
    overflow-x: scroll;
  }
`;

const Pedalboard = ({ theme, board, pedalsCtx }) => {
  const dispatch = useDispatch();
  const [pedalActive, setPedalActive] = useState(false);
  
  const { pedalsList: pedals, setPedalsList: setPedals } = pedalsCtx.state;

  const setBoard = (value) => dispatch(setBoardAction(value));

  const rotatePedal = () => {
    const pedal = pedalActive;
    const myPedals = pedals.map((item) => {
      if (item.key === pedal) {
        item.rotate = item.rotate ? item.rotate >= 360 ? 90 : item.rotate + 90 : 90;
      }
      return item;
    });
    setPedals(myPedals);
    setPedalActive(null);
  }
  
  const removePedal = () => {
    const pedal = pedalActive;
    let myPedals = [...pedals];
    myPedals = myPedals.map((a) => {
      if (a) {
        if (a.key === pedal) {
          return null;
        }
      }

      return a;
    });

    setPedals(myPedals);
    setPedalActive(false);
  }

  return <Layout>
    <WrapperContainer theme={theme}>
      {
        board && board.id && <>
          <Board board={board} scale={theme.scale}>
            {
              pedals.map((pedal, key) => pedal && (
                <Pedal
                  key={key}
                  pedal={pedal}
                  width={(pedal.width * 2.54) * theme.scale}
                  height={(pedal.height * 2.54) * theme.scale}
                  setActivePedal={setPedalActive}
                  activePedal={pedalActive}
                />
              ))
            }
          </Board>
          {
            !pedalActive
              ? (
                <Grid
                  container
                  spacing={2}
                  style={{
                    paddingTop: theme.spacing,
                    marginTop: 0,
                    marginBottom: 0,
                    justifyContent: 'center'
                  }}
                >
                  <Grid item>
                    <Button variant="contained" color="primary" size={window.innerWidth > 560 ? "large" : "small"} href={board.link} target="_blank" style={{
                      paddingRight: 46,
                      paddingLeft: 46,
                    }}>
                      <b>COMPRAR PEDALBOARD</b>
                    </Button>
                  </Grid>
                </Grid>
              )
              : (
                <Grid
                  container
                  spacing={2}
                  style={{
                    paddingTop: theme.spacing,
                    // height: 50,
                    justifyContent: 'center',
                    position: 'fixed',
                    zIndex: 9999999,
                    bottom: 16,
                    left: '50%',
                    transform: 'translateX(-50%)'
                  }}
                >
                  <Grid container item xs={2} style={{ justifyContent: 'center' }}>
                    <IconButton color="primary" onClick={removePedal}>
                      <DeleteOutlined />
                    </IconButton>
                  </Grid>
                  <Grid container item xs={2} style={{ justifyContent: 'center' }}>
                    <Button color="secondary" onClick={rotatePedal} startIcon={<RotateRightOutlined />}>
                      Girar
                    </Button>
                  </Grid>
                </Grid>
              )
          }
        </>
      }
    </WrapperContainer>
  </Layout>
}

export default withTheme(connect(state => ({ board: state.board }))(withPedalsProvider(withPedalsCtx(Pedalboard))));